import styled from 'styled-components'

export const PillContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
